import { FC, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ContentResponse } from '../types/shared';
import { ContentResponseLink } from '../types/links';

interface IContentLinkProps {
  contentResponse: ContentResponse;
}

const ContentLink: FC<IContentLinkProps> = ({ contentResponse }): ReactNode => {
  const content = contentResponse.content as ContentResponseLink;

  return <Link to={content.linkUrl}>{contentResponse.name}</Link>;
};

export default ContentLink;
